import { PromptsPanel } from '@/components/panels/PromptsPanel.js';
import { Button } from '@/components/ui/button.js';
import { X } from 'lucide-react';

interface PromptsOverlayProps {
  onClose?: () => void;
}

export function PromptsOverlay({ onClose }: PromptsOverlayProps) {
  return (
    <>
      {/* Background overlay - click to close */}
      <div
        className="absolute inset-0 bg-black/20 z-30 animate-in fade-in duration-200"
        onClick={onClose}
      />

      {/* Slide-in panel */}
      <div className="absolute right-0 top-0 bottom-0 w-96 bg-muted/30 backdrop-blur-sm border-l border-border shadow-2xl z-40 animate-slide-in-right flex flex-col">
        {/* Header with close button */}
        <div className="flex items-center justify-between border-b p-4">
          <h2 className="text-lg font-semibold">Prompts</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-8 w-8 -mr-2"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="flex-1 overflow-hidden">
          <PromptsPanel hideHeader />
        </div>
      </div>
    </>
  );
}
